var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.68,
    d: "M22 5.907a8.3 8.3 0 0 1-2.356.637 4.07 4.07 0 0 0 1.804-2.234 8.4 8.4 0 0 1-2.607.98 4.12 4.12 0 0 0-2.995-1.275c-2.266 0-4.103 1.81-4.103 4.04q0 .476.106.92a11.7 11.7 0 0 1-8.456-4.22 3.96 3.96 0 0 0-.554 2.03 4.02 4.02 0 0 0 1.824 3.362 4.15 4.15 0 0 1-1.858-.507v.05c0 1.958 1.415 3.591 3.29 3.963-.352.094-.715.141-1.08.141q-.397 0-.773-.075a4.1 4.1 0 0 0 3.832 2.807 8.3 8.3 0 0 1-5.095 1.727q-.498-.001-.979-.056a11.73 11.73 0 0 0 6.289 1.818c7.547 0 11.673-6.157 11.673-11.496l-.014-.523A8.1 8.1 0 0 0 22 5.907"
  })));
};
export default SvgTwitter;